



















































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import * as service from '@/services/rules-report';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
  },
})
export default class RulesReport extends BaseComponent {
  public error: boolean = false;
  public loading: boolean = false;
  public loadingXls: boolean = false;

  public filter: any = {
    term: '',
    client: null,
    status: null,
  };

  public headers: any = [
    { text: 'Código', value: 'codigo', sortable: true },
    { text: 'Descrição', value: 'descricao', sortable: true },
    { text: 'Tipo', value: 'tipo', sortable: true },
    { text: 'Hierarquia', value: 'hierarquia', sortable: true },
    { text: 'Referência', value: 'referenciaHierarquia', sortable: true },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Condições', value: '', sortable: false },
    { text: 'Mensagem', value: 'mensagem', sortable: true },
    { text: 'Explicação', value: 'txtExplicativo', sortable: true },
  ];
  public data: any[] = [];
  public pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public beforeMount(): void {
    this.load();
  }

  public onFilter(): void {
    this.load();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    service.getRulesDataReport(this.buildFilters()).subscribe(
      (data) => {
        this.data = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private buildFilters() {
    let filters = {};
    return filters;
  }

  public exportXls() {
    this.loadingXls = true;
    let filters = this.buildFilters();

    this.loader.start("Processando ...")
    service.buildRulesXlsReport(filters).subscribe(
      (r) => {
        this.forceFileAxiosResponseDownload(r, 'regras.xls');
        this.loadingXls = false;
        this.loader.stop();
      },
      (error) => {
        this.loadingXls = false;
        this.showToastApiError(error);
        this.loader.stop();
      },
    );
  }
}
